module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Alterar senha")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20 container-password-check",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro!")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doChange.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('oldPassword')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha atual")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "old-password",
      "type": "password",
      "name": "oldPassword",
      "placeholder": "Digite sua senha atual"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("oldPassword")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                    'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                  "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite sua nova senha"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("password")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('passwordRepeat')
    }
  }, [_c('label', {
    attrs: {
      "for": "passwordRepeat"
    }
  }, [_vm._v("Confirme a nova senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRepeat),
      expression: "passwordRepeat"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (
        'required|min:8|max:20|confirmed:password|moveMaisCPF'
      ),
      expression: "\n                    'required|min:8|max:20|confirmed:password|moveMaisCPF'\n                  "
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "passwordRepeat",
      "type": "password",
      "name": "passwordRepeat",
      "data-vv-validate-on": "blur",
      "placeholder": "Confirme a nova senha"
    },
    domProps: {
      "value": (_vm.passwordRepeat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRepeat = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("passwordRepeat")) + "\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                Definir nova senha\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter de 8 a 20 caracteres")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter pelo menos um número")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("Senha deve ter uma letra maiúscula")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                Senha deve ter um caractere especial\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5e660864!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/password-change.vue
// module id = 2144
// module chunks = 1